export const getWeightUnit = (
  measurementUnit: string,
  unitMultiplier: number,
  quantity: number
) => {
  if (measurementUnit === 'un') return measurementUnit

  return unitMultiplier * quantity * 1000 * 1 >= 1000 ? 'kg' : 'g'
}
